import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ticketIconsMap } from '../../../../constants/ticket-icons.constant';
import { AuthService } from '../../../../../../auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-map-filter-new',
  templateUrl: './tickets-map-filter.component.html',
  styleUrls: ['./tickets-map-filter.component.scss'],
  standalone: false,
})
export class TicketsMapFilterComponent {
  @Input() ticketsCurrentFilter;
  @Input() brigadeAssign;

  ticketIconsMap = ticketIconsMap;

  constructor(private authService: AuthService) {}

  get isGRS() {
    return this.authService.isGRSUser();
  }

  public onChangeTicketType(type): void {
    this.ticketsCurrentFilter.changeTypeSelected(type);
  }

  public assignBrigades(): void {
    this.brigadeAssign.assignBrigades();
  }

  public filterIconMap = (ticketIconMap) => {
    return ticketIconMap.filter((ticketIcon) => ticketIcon.id !== 3);
  };
}
